export const IconLogo = ({ color }: { color: string }) => (
  <svg
    width="38"
    height="38"
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.2573 0.00189776C15.3935 -0.0527202 11.605 1.07276 8.39772 3.22802C5.19044 5.38329 2.71704 8.46576 1.3078 12.0638C-0.101429 15.6618 -0.379408 19.6042 0.510988 23.3644C1.40138 27.1246 3.41777 30.5236 6.29088 33.1076L18.2365 22.0724H6.21088L29.2028 5.73471L29.4483 6.01059L20.2201 16.7699H30.5877L12.8293 36.9699C15.4292 37.8628 18.1919 38.1808 20.9267 37.9021C23.6615 37.6234 26.3032 36.7545 28.6696 35.3555C31.0359 33.9565 33.0705 32.0607 34.6329 29.7989C36.1953 27.5372 37.2484 24.9633 37.7193 22.255C38.1902 19.5466 38.0678 16.7684 37.3606 14.1119C36.6534 11.4555 35.3781 8.98419 33.6229 6.86854C31.8677 4.75289 29.6743 3.04331 27.1941 1.8578C24.7139 0.672295 22.006 0.0390885 19.2573 0.00189776V0.00189776Z"
      fill={color}
    />
  </svg>
);

export const IconDiscord = () => (
  <svg
    width="21"
    height="16"
    viewBox="0 0 21 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.46071 0.785889L7.6295 0.994199C4.59127 1.89625 3.19031 3.26668 3.19031 3.26668C3.19031 3.26668 3.56165 3.05851 4.18617 2.76361C5.99223 1.94829 7.42695 1.72278 8.01772 1.67074C8.119 1.65339 8.20339 1.63604 8.30467 1.63604C9.33429 1.49727 10.4989 1.46257 11.7142 1.60135C13.3177 1.79217 15.0394 2.27789 16.7948 3.26668L16.7801 3.25272C16.6276 3.11044 15.2875 1.91097 12.5919 1.06359L12.8283 0.785889L12.9026 0.78647C13.3164 0.796297 15.3965 0.931201 17.5713 2.60749C17.5713 2.60749 20.0019 7.1351 20.0019 12.7209C20.0019 12.7209 18.5671 15.2362 14.8369 15.3577C14.8369 15.3577 14.4248 14.8518 13.9965 14.305L13.8131 14.0696C13.7828 14.0304 13.7526 13.9913 13.7228 13.9525C15.934 13.3107 16.778 11.8882 16.778 11.8882C16.0859 12.3566 15.4276 12.6862 14.8369 12.9117C13.9929 13.276 13.1827 13.5189 12.3894 13.6576C10.769 13.9699 9.28365 13.8831 8.01772 13.6403C7.05561 13.4495 6.22854 13.1719 5.5365 12.8944C5.14828 12.7382 4.7263 12.5474 4.30433 12.3046C4.25369 12.2699 4.20305 12.2525 4.15242 12.2178C4.11866 12.2005 4.10178 12.1831 4.0849 12.1658C3.78108 11.9923 3.61229 11.8709 3.61229 11.8709C3.61229 11.8709 4.42248 13.2587 6.56612 13.9178C6.50986 13.9911 6.45214 14.0658 6.39397 14.1408L6.21919 14.3654C5.81302 14.8854 5.43522 15.3577 5.43522 15.3577C1.70495 15.2362 0.287109 12.7209 0.287109 12.7209C0.287109 7.1351 2.71769 2.60749 2.71769 2.60749C4.89243 0.931201 6.97258 0.796297 7.3864 0.78647L7.46071 0.785889ZM6.9881 7.25653C6.02599 7.25653 5.26643 8.12389 5.26643 9.18207C5.26643 10.2402 6.04287 11.1076 6.9881 11.1076C7.95021 11.1076 8.70976 10.2402 8.70976 9.18207C8.72664 8.12389 7.95021 7.25653 6.9881 7.25653ZM13.149 7.25653C12.1868 7.25653 11.4273 8.12389 11.4273 9.18207C11.4273 10.2402 12.2037 11.1076 13.149 11.1076C14.1111 11.1076 14.8706 10.2402 14.8706 9.18207C14.8706 8.12389 14.1111 7.25653 13.149 7.25653Z"
      fill="white"
    />
  </svg>
);

export const IconTwitter = () => (
  <svg
    width="19"
    height="17"
    viewBox="0 0 19 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.8819 3.08208C16.6447 2.60069 17.23 1.83738 17.5047 0.928089C16.7905 1.37493 16.0013 1.69809 15.1592 1.87304C14.4872 1.1153 13.5268 0.642822 12.4639 0.642822C10.4248 0.642822 8.77236 2.38674 8.77236 4.53739C8.77236 4.84271 8.80301 5.14024 8.8664 5.42439C5.79818 5.2617 3.07757 3.71279 1.25502 1.35488C0.936999 1.9321 0.755272 2.60069 0.755272 3.31386C0.755272 4.66442 1.40716 5.85675 2.39821 6.55654C1.7928 6.53648 1.22332 6.35931 0.724633 6.06958V6.1175C0.724633 8.00516 1.99672 9.5797 3.68825 9.93629C3.37763 10.0277 3.05221 10.0733 2.71411 10.0733C2.47639 10.0733 2.24395 10.0499 2.01996 10.0043C2.48907 11.5509 3.85307 12.6786 5.46959 12.7087C4.2049 13.754 2.61269 14.3758 0.883115 14.3758C0.585168 14.3758 0.290391 14.359 0.00195312 14.3223C1.63643 15.4266 3.57731 16.0718 5.66294 16.0718C12.4566 16.0718 16.1693 10.1369 16.1693 4.9898C16.1693 4.82042 16.1672 4.65216 16.1598 4.48613C16.8814 3.93676 17.509 3.25034 18.0024 2.4692C17.3399 2.77898 16.6278 2.98847 15.8819 3.08208Z"
      fill="white"
    />
  </svg>
);

export const IconMedium = () => (
  <svg
    width="18"
    height="11"
    viewBox="0 0 18 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.07675 0.357422C7.88056 0.357422 10.1533 2.66014 10.1533 5.50049C10.1533 8.34083 7.88039 10.6434 5.07675 10.6434C2.2731 10.6434 0 8.34083 0 5.50049C0 2.66014 2.27293 0.357422 5.07675 0.357422ZM13.1839 0.658689C14.5859 0.658689 15.7223 2.82622 15.7223 5.50049C15.7225 8.17406 14.586 10.3423 13.1841 10.3423C11.7822 10.3423 10.6457 8.17406 10.6457 5.50049C10.6457 2.82691 11.782 0.658689 13.1839 0.658689ZM17.1077 1.163C17.6006 1.163 18.0004 3.10492 18.0004 5.50049C18.0004 7.89535 17.6008 9.83797 17.1077 9.83797C16.6146 9.83797 16.2151 7.89587 16.2151 5.50049C16.2151 3.1051 16.6147 1.163 17.1077 1.163Z"
      fill="white"
    />
  </svg>
);

export const IconInstagram = () => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.99942 2.12112C11.4027 2.12112 11.6873 2.13027 12.6364 2.17357C13.514 2.21362 13.9905 2.36025 14.3077 2.48347C14.7278 2.64675 15.0277 2.84182 15.3426 3.15676C15.6575 3.4717 15.8526 3.77157 16.0159 4.19165C16.1391 4.50885 16.2857 4.98542 16.3258 5.86293C16.3691 6.81204 16.3782 7.09668 16.3782 9.49994C16.3782 11.9032 16.3691 12.1879 16.3258 13.1369C16.2857 14.0145 16.1391 14.491 16.0159 14.8082C15.8526 15.2283 15.6575 15.5282 15.3426 15.8431C15.0277 16.1581 14.7278 16.3531 14.3077 16.5164C13.9905 16.6396 13.514 16.7863 12.6364 16.8263C11.6875 16.8696 11.4028 16.8788 8.99942 16.8788C6.59601 16.8788 6.31137 16.8696 5.36244 16.8263C4.4849 16.7863 4.00832 16.6396 3.69117 16.5164C3.27104 16.3531 2.97118 16.1581 2.65624 15.8431C2.3413 15.5282 2.14623 15.2283 1.98299 14.8082C1.85973 14.491 1.7131 14.0145 1.67305 13.137C1.62975 12.1879 1.6206 11.9032 1.6206 9.49994C1.6206 7.09668 1.62975 6.81204 1.67305 5.86296C1.7131 4.98542 1.85973 4.50885 1.98299 4.19165C2.14623 3.77157 2.3413 3.4717 2.65624 3.15676C2.97118 2.84182 3.27104 2.64675 3.69117 2.48347C4.00832 2.36025 4.4849 2.21362 5.36241 2.17357C6.31152 2.13027 6.59616 2.12112 8.99942 2.12112ZM10.1203 0.500488C11.5742 0.504132 11.9218 0.517548 12.7103 0.553529C13.6684 0.59726 14.3226 0.749389 14.8952 0.971902C15.487 1.20192 15.989 1.50968 16.4893 2.01004C16.9897 2.51041 17.2975 3.01235 17.5275 3.60422C17.75 4.17676 17.9021 4.831 17.9458 5.78904C17.9521 5.92618 17.9577 6.04998 17.9626 6.16859L17.9696 6.34361C17.9892 6.8631 17.9971 7.35973 17.9993 8.57509L18 9.2461L18 9.49994C18 9.58725 18 9.67182 18 9.75379L17.9993 10.4248C17.9975 11.4376 17.9917 11.9513 17.9785 12.395L17.9728 12.5698C17.9656 12.7717 17.9568 12.9709 17.9458 13.2108C17.9021 14.1689 17.75 14.8231 17.5275 15.3957C17.2975 15.9875 16.9897 16.4895 16.4893 16.9898C15.989 17.4902 15.487 17.798 14.8952 18.028C14.3226 18.2505 13.6684 18.4026 12.7103 18.4464C11.8875 18.4839 11.5448 18.4969 9.92428 18.4998L9.25327 18.5005L8.99942 18.5005C8.91212 18.5005 8.82755 18.5005 8.74557 18.5005L8.07457 18.4998C6.85922 18.4976 6.3626 18.4898 5.84311 18.4701L5.66808 18.4632C5.54947 18.4582 5.42567 18.4526 5.28852 18.4464C4.33048 18.4026 3.67623 18.2505 3.1037 18.028C2.51183 17.798 2.00989 17.4902 1.50952 16.9898C1.00916 16.4895 0.701396 15.9875 0.471381 15.3957C0.248868 14.8231 0.096739 14.1689 0.0530082 13.2108C0.0420577 12.9709 0.0331992 12.7717 0.0260715 12.5698L0.0203775 12.395C0.00804084 11.9809 0.00221294 11.5058 0 10.6208V8.37906C0.00268714 7.30448 0.0107046 6.83424 0.0292334 6.34361L0.0362177 6.16859C0.0411763 6.04998 0.0467508 5.92618 0.0530082 5.78904C0.096739 4.831 0.248868 4.17676 0.471381 3.60422C0.701396 3.01235 1.00916 2.51041 1.50952 2.01004C2.00989 1.50968 2.51183 1.20192 3.1037 0.971902C3.67623 0.749389 4.33048 0.59726 5.28852 0.553529C5.42567 0.547271 5.54947 0.541696 5.66808 0.536737L5.84311 0.52975C6.33374 0.511214 6.80397 0.503182 7.87854 0.500488H10.1203ZM9.0173 4.8925C6.46283 4.8925 4.39201 6.96332 4.39201 9.51779C4.39201 12.0723 6.46283 14.1431 9.0173 14.1431C11.5718 14.1431 13.6426 12.0723 13.6426 9.51779C13.6426 6.96332 11.5718 4.8925 9.0173 4.8925ZM9.0173 6.5154C10.6755 6.5154 12.0197 7.85963 12.0197 9.51779C12.0197 11.1759 10.6755 12.5202 9.0173 12.5202C7.35915 12.5202 6.01491 11.1759 6.01491 9.51779C6.01491 7.85963 7.35915 6.5154 9.0173 6.5154ZM13.7855 3.6067C13.1937 3.6067 12.714 4.0864 12.714 4.67818C12.714 5.26996 13.1937 5.74969 13.7855 5.74969C14.3772 5.74969 14.8569 5.26996 14.8569 4.67818C14.8569 4.0864 14.3772 3.6067 13.7855 3.6067Z"
      fill="white"
    />
  </svg>
);

export const IconLinkedin = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="26" height="26" rx="12.5" fill="#0077B7" />
    <path
      d="M8.905 6.04134C8.905 6.84692 8.2575 7.49967 7.45833 7.49967C6.65917 7.49967 6.01167 6.84692 6.01167 6.04134C6.01167 5.23634 6.65917 4.58301 7.45833 4.58301C8.2575 4.58301 8.905 5.23634 8.905 6.04134ZM8.91667 8.66634H6V17.9997H8.91667V8.66634ZM13.5728 8.66634H10.6748V17.9997H13.5734V13.1003C13.5734 10.3761 17.0903 10.1533 17.0903 13.1003V17.9997H20V12.0899C20 7.49326 14.7955 7.66067 13.5728 9.92342V8.66634Z"
      fill="white"
    />
  </svg>
);
export const IconWhiteLinkedin = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.21659 2.04134C3.21659 2.84692 2.61836 3.49967 1.88 3.49967C1.14164 3.49967 0.543402 2.84692 0.543402 2.04134C0.543402 1.23634 1.14164 0.583008 1.88 0.583008C2.61836 0.583008 3.21659 1.23634 3.21659 2.04134ZM3.22737 4.66634H0.532623V13.9997H3.22737V4.66634ZM7.52926 4.66634H4.85176V13.9997H7.5298V9.10026C7.5298 6.37609 10.7791 6.15326 10.7791 9.10026V13.9997H13.4674V8.08992C13.4674 3.49326 8.6589 3.66067 7.52926 5.92342V4.66634Z"
      fill="white"
    />
  </svg>
);

export const IconBigDiscord = () => (
  <svg
    width="40"
    height="30"
    viewBox="0 0 40 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M33.8617 2.48684C31.3122 1.33579 28.5783 0.487746 25.7198 0.00203748C25.6678 -0.00733654 25.6158 0.0160897 25.589 0.0629432C25.2374 0.678276 24.8479 1.48103 24.5752 2.11199C21.5007 1.65908 18.442 1.65908 15.4305 2.11199C15.1577 1.467 14.7541 0.678276 14.401 0.0629432C14.3741 0.0176529 14.3221 -0.00577328 14.2701 0.00203748C11.4132 0.486194 8.67927 1.33424 6.12823 2.48684C6.10614 2.4962 6.08721 2.51184 6.07465 2.53213C0.888986 10.1552 -0.531584 17.5909 0.1653 24.9344C0.168453 24.9703 0.18895 25.0047 0.21733 25.0265C3.63868 27.4988 6.95285 28.9997 10.2055 29.9945C10.2575 30.0102 10.3127 29.9914 10.3458 29.9492C11.1152 28.9154 11.8011 27.8253 12.3891 26.6789C12.4238 26.6117 12.3907 26.5321 12.3198 26.5055C11.2319 26.0995 10.196 25.6044 9.19955 25.0422C9.12073 24.9969 9.11442 24.8859 9.18693 24.8328C9.39662 24.6782 9.60637 24.5173 9.80659 24.3549C9.84282 24.3253 9.8933 24.319 9.93589 24.3377C16.4821 27.2786 23.5692 27.2786 30.0383 24.3377C30.0808 24.3175 30.1313 24.3237 30.1691 24.3534C30.3694 24.5158 30.5791 24.6782 30.7904 24.8328C30.8629 24.8859 30.8581 24.9969 30.7793 25.0422C29.7829 25.6153 28.747 26.0995 27.6575 26.504C27.5866 26.5305 27.555 26.6117 27.5897 26.6789C28.1904 27.8236 28.8763 28.9138 29.6315 29.9477C29.663 29.9914 29.7198 30.0102 29.7718 29.9945C33.0402 28.9997 36.3544 27.4988 39.7757 25.0265C39.8057 25.0047 39.8246 24.9719 39.8278 24.9359C40.6618 16.446 38.4308 9.07133 33.9137 2.53368C33.9026 2.51184 33.8838 2.4962 33.8617 2.48684ZM13.3667 20.463C11.3958 20.463 9.77189 18.6826 9.77189 16.496C9.77189 14.3095 11.3643 12.5291 13.3667 12.5291C15.3848 12.5291 16.993 14.3252 16.9615 16.496C16.9615 18.6826 15.369 20.463 13.3667 20.463ZM26.6579 20.463C24.6871 20.463 23.0632 18.6826 23.0632 16.496C23.0632 14.3095 24.6556 12.5291 26.6579 12.5291C28.6761 12.5291 30.2842 14.3252 30.2527 16.496C30.2527 18.6826 28.6761 20.463 26.6579 20.463Z"
      fill="white"
    />
  </svg>
);

export const IconRoadMap = () => (
  <svg
    width="979"
    height="246"
    viewBox="0 0 979 246"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.94 3.99998H56.36C75.6267 3.99998 89.68 8.53332 98.52 17.6C107.36 26.44 111.78 40.1533 111.78 58.74V73.36C111.78 98.0667 103.62 113.707 87.3 120.28V120.96C96.3667 123.68 102.713 129.233 106.34 137.62C110.193 146.007 112.12 157.227 112.12 171.28V213.1C112.12 219.9 112.347 225.453 112.8 229.76C113.253 233.84 114.387 237.92 116.2 242H78.12C76.76 238.147 75.8533 234.52 75.4 231.12C74.9467 227.72 74.72 221.6 74.72 212.76V169.24C74.72 158.36 72.9067 150.767 69.28 146.46C65.88 142.153 59.8733 140 51.26 140H38.34V242H0.94V3.99998ZM51.94 106C59.42 106 64.9733 104.073 68.6 100.22C72.4533 96.3667 74.38 89.9067 74.38 80.84V62.48C74.38 53.8667 72.7933 47.6333 69.62 43.78C66.6733 39.9267 61.9133 38 55.34 38H38.34V106H51.94ZM192.129 245.4C173.769 245.4 159.716 240.187 149.969 229.76C140.222 219.333 135.349 204.6 135.349 185.56V60.44C135.349 41.4 140.222 26.6667 149.969 16.24C159.716 5.81332 173.769 0.599987 192.129 0.599987C210.489 0.599987 224.542 5.81332 234.289 16.24C244.036 26.6667 248.909 41.4 248.909 60.44V185.56C248.909 204.6 244.036 219.333 234.289 229.76C224.542 240.187 210.489 245.4 192.129 245.4ZM192.129 211.4C205.049 211.4 211.509 203.58 211.509 187.94V58.06C211.509 42.42 205.049 34.6 192.129 34.6C179.209 34.6 172.749 42.42 172.749 58.06V187.94C172.749 203.58 179.209 211.4 192.129 211.4ZM302.438 3.99998H353.098L391.858 242H354.458L347.658 194.74V195.42H305.158L298.358 242H263.678L302.438 3.99998ZM343.238 163.12L326.578 45.48H325.898L309.578 163.12H343.238ZM410.003 3.99998H467.123C485.709 3.99998 499.649 8.98665 508.943 18.96C518.236 28.9333 522.883 43.5533 522.883 62.82V183.18C522.883 202.447 518.236 217.067 508.943 227.04C499.649 237.013 485.709 242 467.123 242H410.003V3.99998ZM466.443 208C472.563 208 477.209 206.187 480.383 202.56C483.783 198.933 485.483 193.04 485.483 184.88V61.12C485.483 52.96 483.783 47.0667 480.383 43.44C477.209 39.8133 472.563 38 466.443 38H447.403V208H466.443ZM548.128 3.99998H601.508L625.308 174.34H625.988L649.788 3.99998H703.168V242H667.808V61.8H667.128L639.928 242H608.648L581.448 61.8H580.768V242H548.128V3.99998ZM759.977 3.99998H810.637L849.397 242H811.997L805.197 194.74V195.42H762.697L755.897 242H721.217L759.977 3.99998ZM800.777 163.12L784.117 45.48H783.437L767.117 163.12H800.777ZM867.542 3.99998H922.622C941.208 3.99998 955.148 8.98665 964.442 18.96C973.735 28.9333 978.382 43.5533 978.382 62.82V86.28C978.382 105.547 973.735 120.167 964.442 130.14C955.148 140.113 941.208 145.1 922.622 145.1H904.942V242H867.542V3.99998ZM922.622 111.1C928.742 111.1 933.275 109.4 936.222 106C939.395 102.6 940.982 96.82 940.982 88.66V60.44C940.982 52.28 939.395 46.5 936.222 43.1C933.275 39.7 928.742 38 922.622 38H904.942V111.1H922.622Z"
      fill="#202020"
    />
  </svg>
);

export const IconRunner = () => (
  <svg
    width="1400"
    height="490"
    viewBox="0 0 1400 490"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M36.5668 294H12.5568L16.4768 255.78H40.4868L49.7968 166.11H25.2968L29.2168 127.89H53.7168L62.0468 49H104.677L96.3468 127.89H131.137L139.467 49H182.097L173.767 127.89H198.757L194.837 166.11H169.847L160.537 255.78H185.527L181.607 294H156.617L146.327 392H103.697L113.987 294H79.1968L68.9068 392H26.2768L36.5668 294ZM117.907 255.78L127.217 166.11H92.4268L83.1168 255.78H117.907ZM226.74 49H306.61C334.377 49 354.63 55.5333 367.37 68.6C380.11 81.34 386.48 101.103 386.48 127.89V148.96C386.48 184.567 374.72 207.107 351.2 216.58V217.56C364.267 221.48 373.414 229.483 378.64 241.57C384.194 253.657 386.97 269.827 386.97 290.08V350.35C386.97 360.15 387.297 368.153 387.95 374.36C388.604 380.24 390.237 386.12 392.85 392H337.97C336.01 386.447 334.704 381.22 334.05 376.32C333.397 371.42 333.07 362.6 333.07 349.86V287.14C333.07 271.46 330.457 260.517 325.23 254.31C320.33 248.103 311.674 245 299.26 245H280.64V392H226.74V49ZM300.24 196C311.02 196 319.024 193.223 324.25 187.67C329.804 182.117 332.58 172.807 332.58 159.74V133.28C332.58 120.867 330.294 111.883 325.72 106.33C321.474 100.777 314.614 98 305.14 98H280.64V196H300.24ZM502.767 396.9C476.634 396.9 456.707 389.55 442.987 374.85C429.267 359.823 422.407 338.427 422.407 310.66V49H476.307V314.58C476.307 326.34 478.594 334.833 483.167 340.06C488.067 345.287 494.927 347.9 503.747 347.9C512.567 347.9 519.264 345.287 523.837 340.06C528.737 334.833 531.187 326.34 531.187 314.58V49H583.127V310.66C583.127 338.427 576.267 359.823 562.547 374.85C548.827 389.55 528.901 396.9 502.767 396.9ZM621.516 49H689.136L741.566 254.31H742.546V49H790.566V392H735.196L670.516 141.61H669.536V392H621.516V49ZM830.627 49H898.247L950.677 254.31H951.657V49H999.677V392H944.307L879.627 141.61H878.647V392H830.627V49ZM1039.74 49H1186.74V98H1093.64V188.65H1167.63V237.65H1093.64V343H1186.74V392H1039.74V49ZM1217.75 49H1297.62C1325.38 49 1345.64 55.5333 1358.38 68.6C1371.12 81.34 1377.49 101.103 1377.49 127.89V148.96C1377.49 184.567 1365.73 207.107 1342.21 216.58V217.56C1355.27 221.48 1364.42 229.483 1369.65 241.57C1375.2 253.657 1377.98 269.827 1377.98 290.08V350.35C1377.98 360.15 1378.3 368.153 1378.96 374.36C1379.61 380.24 1381.24 386.12 1383.86 392H1328.98C1327.02 386.447 1325.71 381.22 1325.06 376.32C1324.4 371.42 1324.08 362.6 1324.08 349.86V287.14C1324.08 271.46 1321.46 260.517 1316.24 254.31C1311.34 248.103 1302.68 245 1290.27 245H1271.65V392H1217.75V49ZM1291.25 196C1302.03 196 1310.03 193.223 1315.26 187.67C1320.81 182.117 1323.59 172.807 1323.59 159.74V133.28C1323.59 120.867 1321.3 111.883 1316.73 106.33C1312.48 100.777 1305.62 98 1296.15 98H1271.65V196H1291.25Z"
      fill="#202020"
    />
  </svg>
);

export const IconBack = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1362_728)">
      <path
        d="M4.16602 10H15.8327"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.16602 10L9.16602 15"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.16602 10L9.16602 5"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1362_728">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const IconClose = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.435 1.97922L26.0208 0.565005L14 12.5858L1.97918 0.565005L0.564971 1.97922L12.5858 14L0.564971 26.0208L1.97918 27.4351L14 15.4142L26.0208 27.4351L27.435 26.0208L15.4142 14L27.435 1.97922Z"
      fill="white"
    />
  </svg>
);

export const IconCloseSm = () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.33341 1.66675L1.66675 8.33341M1.66675 1.66675L8.33341 8.33341L1.66675 1.66675Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconWallet = () => (
  <svg
    width="240px"
    height="240px"
    viewBox="0 0 240 240"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <title>wallet</title>
    <desc>Created with Sketch.</desc>
    <g id="wallet" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="bounding-box">
        <polygon id="shape" points="0 0 240 0 240 240 0 240"></polygon>
      </g>
      <rect
        id="Rectangle"
        stroke="#FFF"
        strokeWidth="10"
        x="35"
        y="75"
        width="170"
        height="120"
        rx="15"
      ></rect>
      <path
        d="M35,75 C35,85 35,86.6666667 35,80 C35,73.3333333 35,70 35,70 C35,61.7157288 41.7157288,55 50,55 L140,55 C148.284271,55 155,61.7157288 155,70 L155,75 L35,75 Z"
        id="Path"
        stroke="#FFF"
        strokeWidth="10"
        fill="#FFF"
      ></path>
      <path
        d="M205,155 L205,115 L154,115 C142.954305,115 134,123.954305 134,135 C134,146.045695 142.954305,155 154,155 L205,155 Z"
        id="Rectangle"
        stroke="#FFF"
        strokeWidth="10"
        fill="#FFF"
      ></path>
    </g>
  </svg>
);

export const IconThumb = () => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.57681 0L8.65466 3.89783L4.895 6.95915C4.4293 7.33839 4.15976 7.89649 4.15976 8.48204V18.0033C4.15976 19.0946 5.10292 20 6.23964 20H15.2192C16.003 20 16.7235 19.5726 17.0757 18.9022L20.6282 12.14C20.743 11.9257 20.7988 11.689 20.7988 11.4575V9.01823C20.7988 7.92699 19.8556 7.02155 18.7189 7.02155H13.9721C14.2654 6.14606 14.5592 5.01142 14.5592 3.89003C14.5592 2.15721 13.4297 1.02137 12.4224 0.540117C11.4151 0.0588745 10.442 0.0331464 10.442 0.0331464L9.57681 0ZM11.1773 2.24432C11.3237 2.28663 11.3415 2.25426 11.4962 2.32817C12.0488 2.59218 12.4793 2.88539 12.4793 3.89003C12.4793 5.27623 11.5206 7.63186 11.5206 7.63186L10.9113 9.01823H18.7189V11.3386L15.2192 18.0033H6.23964V8.48204L10.5294 4.98782L11.1773 2.24432ZM0 7.02155V20H2.07988V7.02155H0Z"
      fill="currentColor"
    />
  </svg>
);

export const IconMobile = () => (
  <svg
    width="72"
    height="72"
    viewBox="0 0 72 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.5 49.5V9H31.5V31.5H36V4.5C36 2.0152 33.9848 0 31.5 0H4.5C2.0152 0 0 2.0152 0 4.5V54C0 56.4848 2.0152 58.5 4.5 58.5H9V49.5H4.5ZM67.5 36H18C15.5152 36 13.5 38.0152 13.5 40.5V67.5C13.5 69.9848 15.5152 72 18 72H67.5C69.9848 72 72 69.9848 72 67.5V40.5C72 38.0152 69.9848 36 67.5 36ZM63 67.5H22.5V40.5H63V67.5ZM45 4.5C54.9254 4.5 63 12.5746 63 22.5H69.75L60.75 31.5L51.75 22.5H58.5C58.5 15.0564 52.4436 9 45 9V4.5Z"
      fill="white"
    />
  </svg>
);

export const IconVerse = () => (
  <svg
    width="1282"
    height="244"
    viewBox="0 0 1282 244"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.05289 60.12C1.05289 128.12 74.1529 137.3 74.1529 186.26C74.1529 203.26 66.6729 209.38 54.7729 209.38C42.8729 209.38 35.3929 203.26 35.3929 186.26V169.26H0.0328913V183.88C0.0328913 221.96 19.0729 243.72 55.7929 243.72C92.5129 243.72 111.553 221.96 111.553 183.88C111.553 115.88 38.4529 106.7 38.4529 57.74C38.4529 40.74 45.2529 34.28 57.1529 34.28C69.0529 34.28 75.8529 40.74 75.8529 57.74V67.6H111.213V60.12C111.213 22.04 92.5129 0.279999 56.1329 0.279999C19.7529 0.279999 1.05289 22.04 1.05289 60.12ZM188.061 2.99998H132.981V241H170.381V151.58H188.061C225.461 151.58 243.821 130.84 243.821 92.76V61.82C243.821 23.74 225.461 2.99998 188.061 2.99998ZM188.061 37C199.961 37 206.421 42.44 206.421 59.44V95.14C206.421 112.14 199.961 117.58 188.061 117.58H170.381V37H188.061ZM341.449 2.99998H286.709L248.629 241H282.969L289.429 197.82H335.329L341.789 241H379.529L341.449 2.99998ZM312.209 45.16L330.229 165.52H294.189L312.209 45.16ZM470.046 152.26V186.26C470.046 203.26 462.566 209.38 450.666 209.38C438.766 209.38 431.286 203.26 431.286 186.26V57.74C431.286 40.74 438.766 34.28 450.666 34.28C462.566 34.28 470.046 40.74 470.046 57.74V83.24H505.406V60.12C505.406 22.04 486.366 0.279999 449.646 0.279999C412.926 0.279999 393.886 22.04 393.886 60.12V183.88C393.886 221.96 412.926 243.72 449.646 243.72C486.366 243.72 505.406 221.96 505.406 183.88V152.26H470.046ZM565.498 37H630.098V2.99998H528.098V241H630.098V207H565.498V137.3H616.838V103.3H565.498V37ZM681.154 2.99998H643.414L680.134 241H735.894L772.614 2.99998H738.274L709.714 197.14L681.154 2.99998ZM827.471 37H892.071V2.99998H790.071V241H892.071V207H827.471V137.3H878.811V103.3H827.471V37ZM1031.53 241C1027.79 232.16 1027.45 223.66 1027.45 212.1V175.38C1027.45 150.56 1021.33 132.54 1002.63 124.72C1019.29 116.9 1027.11 100.92 1027.11 76.44V57.74C1027.11 21.02 1010.45 2.99998 971.686 2.99998H915.246V241H952.646V144.1H965.566C982.566 144.1 990.046 152.26 990.046 174.36V211.76C990.046 231.14 991.406 234.88 993.446 241H1031.53ZM970.666 37C983.926 37 989.706 44.48 989.706 61.48V84.94C989.706 103.98 981.206 110.1 967.266 110.1H952.646V37H970.666ZM1047.28 60.12C1047.28 128.12 1120.38 137.3 1120.38 186.26C1120.38 203.26 1112.9 209.38 1101 209.38C1089.1 209.38 1081.62 203.26 1081.62 186.26V169.26H1046.26V183.88C1046.26 221.96 1065.3 243.72 1102.02 243.72C1138.74 243.72 1157.78 221.96 1157.78 183.88C1157.78 115.88 1084.68 106.7 1084.68 57.74C1084.68 40.74 1091.48 34.28 1103.38 34.28C1115.28 34.28 1122.08 40.74 1122.08 57.74V67.6H1157.44V60.12C1157.44 22.04 1138.74 0.279999 1102.36 0.279999C1065.98 0.279999 1047.28 22.04 1047.28 60.12ZM1216.61 37H1281.21V2.99998H1179.21V241H1281.21V207H1216.61V137.3H1267.95V103.3H1216.61V37Z"
      fill="#202020"
    />
  </svg>
);

export const IconRefresh = () => (
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.70685 1.69378C3.93509 0.702618 5.46348 0.157557 7.04181 0.147589L7.04171 0.147549C11.2048 0.147549 14 3.74539 14 7.10756V7.42864H12.3945V7.10756C12.3945 4.52118 10.243 1.75315 7.04171 1.75796C5.8422 1.77396 4.68186 2.18733 3.74233 2.93322L5.59684 2.88842L5.63055 4.49396L1.03871 4.59184L1.13659 0L2.74213 0.0337106L2.70685 1.69378ZM10.2577 11.2822L8.40967 11.3271L8.37127 9.72146L12.9631 9.62358L12.8652 14.2154L11.2597 14.1817L11.295 12.5216C10.0667 13.5128 8.53834 14.0579 6.96001 14.0678C2.79682 14.0678 0 10.4683 0 7.10782V6.78674H1.60554V7.10782C1.60554 9.69262 3.75696 12.4622 6.95829 12.4574C8.1578 12.4414 9.31814 12.028 10.2577 11.2822Z"
      fill="#FFF96D"
    />
  </svg>
);

export const IconCube = () => (
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.65208 14.9209L0.429858 11.9209C0.16632 11.7937 0 11.5342 0 11.25V3.75004C0 3.46578 0.16632 3.2063 0.429858 3.07907L6.65208 0.0791027C6.87118 -0.0263676 7.12882 -0.0263676 7.34792 0.0791027L13.5701 3.07907C13.8337 3.20629 14 3.46578 14 3.75004V11.25C14 11.5342 13.8337 11.7937 13.5701 11.9209L7.34792 14.9209C7.12882 15.0264 6.87118 15.0264 6.65208 14.9209ZM6.22233 7.21372L1.55566 4.96375V10.7866L6.22233 13.0366V7.21372ZM7.77734 13.0366V7.21372L12.444 4.96375V10.7866L7.77734 13.0366ZM11.4836 3.75001L7.0006 1.58875L2.51758 3.75001L7.0006 5.91127L11.4836 3.75001Z"
      fill="white"
    />
  </svg>
);

export const IconSearch = () => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.0387 12.9851C9.87365 13.7481 7.46845 13.3463 5.66884 11.921L1.58983 15.9998L0.5 14.9099L4.57896 10.8312C3.15367 9.03169 2.75191 6.62649 3.51492 4.46132C4.27802 2.29616 6.09897 0.674396 8.33762 0.165965C10.5765 -0.342281 12.9193 0.334126 14.5427 1.95731C16.1659 3.58091 16.8423 5.92374 16.334 8.16238C15.8256 10.4009 14.2038 12.2219 12.0387 12.9851ZM13.4492 3.05105C12.4852 2.08706 11.1777 1.54545 9.81449 1.54545C8.45126 1.54545 7.14379 2.08706 6.1798 3.05105C5.21581 4.01504 4.67419 5.32251 4.67419 6.68574C4.67419 8.04897 5.21581 9.35645 6.1798 10.3204C7.14379 11.2844 8.45126 11.826 9.81449 11.826C11.1777 11.826 12.4852 11.2844 13.4492 10.3204C14.4132 9.35645 14.9548 8.04897 14.9548 6.68574C14.9548 5.32251 14.4132 4.01504 13.4492 3.05105ZM10.5857 9.76992H9.04351V7.45688H6.73047V5.9147H9.04351V3.60166H10.5857V5.9147H12.8987V7.45688H10.5857V9.76992Z"
      fill="white"
    />
  </svg>
);

export const IconUtilities = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="26" height="26" rx="12" fill="black" />
    <path
      d="M14.4585 12.9453C14.4585 15.6207 12.3044 17.7896 9.64712 17.7896C6.98985 17.7896 4.83594 15.6213 4.83594 12.9453C4.83594 10.2692 6.99002 8.10107 9.64712 8.10107C12.3042 8.10107 14.4585 10.2699 14.4585 12.9453Z"
      fill="white"
    />
    <path
      d="M19.7371 12.945C19.7371 15.4636 18.66 17.5051 17.3315 17.5051C16.0029 17.5051 14.9258 15.4629 14.9258 12.945C14.9258 10.4271 16.0029 8.38495 17.3315 8.38495C18.66 8.38495 19.7371 10.4271 19.7371 12.945Z"
      fill="white"
    />
    <path
      d="M21.8992 12.9454C21.8992 15.2019 21.5203 17.0311 21.0531 17.0311C20.5858 17.0311 20.207 15.2013 20.207 12.9454C20.207 10.6896 20.5858 8.85974 21.0533 8.85974C21.5207 8.85974 21.8992 10.6891 21.8992 12.9454Z"
      fill="white"
    />
  </svg>
);
export const IconBiggerDiscord = () => (
  <svg
    width="128"
    height="128"
    viewBox="0 0 128 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="128" height="128" rx="60" fill="#6E85D3" />
    <path
      d="M77.2784 85.1356C79.2145 87.5676 81.5378 90.3196 81.5378 90.3196C95.8007 89.8716 101.286 80.5916 101.286 80.5916C101.286 59.9836 91.993 43.2796 91.993 43.2796C82.6995 36.3676 73.8578 36.5596 73.8578 36.5596L72.9543 37.5836C83.9258 40.9116 89.0242 45.7116 89.0242 45.7116C82.3123 42.0636 75.7294 40.2716 69.5984 39.5676C64.9516 39.0556 60.4985 39.1836 56.5617 39.6956C56.1745 39.6956 55.8518 39.7596 55.4646 39.8236C53.2058 40.0156 47.72 40.8476 40.8145 43.8556C38.4266 44.9436 37.0068 45.7116 37.0068 45.7116C37.0068 45.7116 42.3634 40.6556 53.9802 37.3276L53.3348 36.5596C53.3348 36.5596 44.4931 36.3676 35.1997 43.2796C35.1997 43.2796 25.9062 59.9836 25.9062 80.5916C25.9062 80.5916 31.3274 89.8716 45.5903 90.3196C45.5903 90.3196 47.9782 87.4396 49.9143 85.0076C41.718 82.5756 38.6202 77.4556 38.6202 77.4556C38.6202 77.4556 39.2656 77.9036 40.4273 78.5436C40.4918 78.6076 40.5563 78.6716 40.6854 78.7356C40.879 78.8636 41.0726 78.9276 41.2663 79.0556C42.8797 79.9516 44.4931 80.6556 45.9775 81.2316C48.6236 82.2556 51.7859 83.2796 55.4646 83.9836C60.3049 84.8796 65.9842 85.1996 72.1799 84.0476C75.2131 83.5356 78.311 82.6396 81.5378 81.2956C83.7967 80.4636 86.3136 79.2476 88.9597 77.5196C88.9597 77.5196 85.7328 82.7676 77.2784 85.1356Z"
      fill="white"
    />
    <path
      d="M51.1315 53.895C47.3602 53.895 44.3828 57.2866 44.3828 61.4244C44.3828 65.5622 47.4263 68.9538 51.1315 68.9538C54.9028 68.9538 57.8802 65.5622 57.8802 61.4244C57.9463 57.2866 54.9028 53.895 51.1315 53.895ZM75.2812 53.895C71.5099 53.895 68.5325 57.2866 68.5325 61.4244C68.5325 65.5622 71.576 68.9538 75.2812 68.9538C79.0525 68.9538 82.0299 65.5622 82.0299 61.4244C82.0299 57.2866 79.0525 53.895 75.2812 53.895Z"
      fill="#6E85D3"
    />
  </svg>
);

export const IconInfo = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.5"
      d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.5"
      d="M12 8H12.01"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.5"
      d="M11 12H12V16H13"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const LinkIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.3391 10.4034L11.3604 9.44638L13.2961 7.51061C14.0901 6.67377 14.5333 5.75932 14.6254 4.7669C14.7176 3.77447 14.4376 2.92366 13.7855 2.21446C13.0763 1.56193 12.2255 1.2819 11.2331 1.37458C10.2406 1.46711 9.32604 1.91015 8.48935 2.70383L6.55358 4.6396L5.59659 3.66086L7.51123 1.74622C8.63158 0.682536 9.87239 0.104607 11.2337 0.0125439C12.595 -0.0795265 13.7648 0.335245 14.7431 1.25669C15.6647 2.23512 16.0795 3.40482 15.9874 4.76612C15.8952 6.12742 15.3174 7.36822 14.2537 8.48857L12.3391 10.4034ZM10.4033 12.3391L8.48857 14.2538C7.36822 15.3175 6.12742 15.8952 4.76612 15.9875C3.40482 16.0795 2.23511 15.6648 1.25669 14.7432C0.335248 13.7649 -0.0795206 12.595 0.0125421 11.2337C0.104612 9.87243 0.682573 8.63162 1.74621 7.51127L3.66086 5.59663L4.6396 6.55362L2.70383 8.48939C1.90969 9.32608 1.46664 10.2407 1.37458 11.2331C1.28236 12.2255 1.56236 13.0763 2.21446 13.7855C2.92366 14.4381 3.77447 14.7181 4.7669 14.6254C5.75932 14.5329 6.67376 14.0898 7.51061 13.2962L9.44638 11.3604L10.4033 12.3391ZM10.4033 4.63964L11.3603 5.59663L5.59581 11.3611L4.63893 10.4042L10.4033 4.63964Z"
      fill="white"
    />
  </svg>
);

export const IconDropdown = () => (
  <svg
    width="10"
    height="6"
    viewBox="0 0 10 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.2723 0L4.75746 3.51484L1.24262 0L0 1.24246L4.75754 6L9.51507 1.24246L8.2723 0Z"
      fill="white"
    />
  </svg>
);

export const IconMinus = () => (
  <svg
    width="16"
    height="1"
    viewBox="0 0 16 1"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="16" height="1" fill="white" />
  </svg>
);

export const IconSearchVote = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_b_478_296)">
      <rect width="30" height="30" rx="15" fill="#252525" fillOpacity="0.5" />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.3081 19.9865C15.3399 20.6802 13.1533 20.3149 11.5173 19.0192L7.80912 22.7271L6.81836 21.7364L10.5265 18.0284C9.23079 16.3925 8.86555 14.206 9.5592 12.2376C10.2529 10.2693 11.9083 8.79497 13.9435 8.33276C15.9788 7.87072 18.1087 8.48564 19.5844 9.96126C21.0601 11.4373 21.675 13.5671 21.2129 15.6022C20.7507 17.6373 19.2764 19.2927 17.3081 19.9865ZM18.5903 10.9556C17.714 10.0792 16.5254 9.58684 15.2861 9.58684C14.0468 9.58684 12.8582 10.0792 11.9818 10.9556C11.1055 11.8319 10.6131 13.0205 10.6131 14.2598C10.6131 15.4991 11.1055 16.6877 11.9818 17.5641C12.8582 18.4405 14.0468 18.9328 15.2861 18.9328C16.5254 18.9328 17.714 18.4405 18.5903 17.5641C19.4667 16.6877 19.9591 15.4991 19.9591 14.2598C19.9591 13.0205 19.4667 11.8319 18.5903 10.9556ZM15.9872 17.0636H14.5852V14.9609H12.4824V13.5589H14.5852V11.4561H15.9872V13.5589H18.0899V14.9609H15.9872V17.0636Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_b_478_296"
        x="-80"
        y="-80"
        width="190"
        height="190"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation="40" />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_478_296"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_478_296"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const IconEmail = () => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="22px"
    height="19px"
    viewBox="0 0 1280.000000 914.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <metadata>
      Created by potrace 1.15, written by Peter Selinger 2001-2017
    </metadata>
    <g
      transform="translate(0.000000,914.000000) scale(0.100000,-0.100000)"
      fill="#fff"
      stroke="none"
    >
      <path
        d="M1195 9129 c-510 -65 -953 -428 -1121 -921 -71 -209 -65 100 -70
-3578 -2 -2270 0 -3345 7 -3410 26 -237 116 -468 257 -660 66 -91 204 -229
290 -290 144 -103 334 -190 511 -232 85 -20 117 -21 2261 -29 1196 -5 3552 -8
5235 -6 l3060 3 85 21 c137 34 207 60 335 123 409 202 684 594 744 1059 8 59
11 1079 11 3445 -1 2774 -3 3371 -14 3416 -42 173 -109 327 -202 467 -71 107
-203 246 -313 329 -88 67 -300 177 -399 208 -30 10 -95 27 -145 39 l-92 22
-5185 1 c-2961 1 -5215 -2 -5255 -7z m7845 -3165 c-1678 -1678 -2471 -2465
-2505 -2485 -69 -40 -150 -41 -217 -1 -29 17 -948 928 -2507 2485 l-2461 2457
5072 0 5073 0 -2455 -2456z m3070 -1326 l-5 -3423 -22 -77 c-58 -204 -153
-318 -326 -391 l-72 -30 -1727 1734 -1727 1734 1937 1938 c1065 1065 1939
1937 1942 1937 3 0 3 -1540 0 -3422z m-9430 1487 l1905 -1905 -1747 -1747
-1747 -1747 -62 29 c-123 59 -208 173 -246 330 -16 65 -18 301 -20 3508 -2
1890 0 3437 4 3437 5 0 865 -857 1913 -1905z m3005 -3000 c451 -455 620 -619
649 -631 50 -20 133 -20 182 1 28 11 207 184 634 610 l595 595 1503 -1503
c826 -826 1502 -1504 1502 -1507 0 -3 -1964 -5 -4365 -5 -2401 0 -4365 2
-4365 5 0 6 3043 3050 3050 3050 3 0 280 -276 615 -615z"
      />
    </g>
  </svg>
);
